<!--
 * @Description: 单票下单
 * @Author: ganjia
 * @Date: 2019-10-15 14:10:50
 -->
<template>
  <div class="main-wrap singleOrder">
    <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
      <el-row :gutter="24">
        <el-col :span="12">
          <h3>{{ $lang('寄件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('寄件人姓名')" prop="senderName">
              <el-autocomplete
                :maxlength="50"
                valueKey="name"
                v-model="formData.senderName"
                @select="changeSenderName"
                :fetch-suggestions="remoteSenderName"
                :placeholder="$lang('请输入寄件人姓名')">
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
                </template>
              </el-autocomplete>
            </el-form-item>
            <!-- <el-form-item :label="$lang('电话区号')" class="el-form-item w80 el-form-item--small" id="areaCodeSty">
               <template slot="label"><span :title="$lang('电话区号')">{{$lang('电话区号')}}</span></template>
               <el-input v-model="formData.senderPhoneAreacode" :disabled="true"></el-input>
            </el-form-item> -->
            <el-form-item :label="$lang('寄件人电话')" prop="senderMobilePhone">
              <!--<el-autocomplete
                    :maxlength="11"
                    valueKey="mobile"
                    @select="changeSenderName"
                    v-model="formData.senderMobilePhone"
                    :fetch-suggestions="remoteSenderMobilePhone"
                    :placeholder="$lang('请输入寄件人电话')">
                  </el-autocomplete>-->
              <base-phone-input v-model="formData.senderMobilePhone"
                                :maxlength="11"
                                isRemote
                                @change="changeSenderName"
                                :fetch-suggestions="remoteSenderMobilePhone"
                                :placeholder="$lang('请输入寄件人电话')"/>
            </el-form-item>
            <el-form-item :label="$lang('寄件人电话') + '2'" prop="senderTelphone">
              <!--              <el-input v-model="formData.senderTelphone" :placeholder="$lang('请输入寄件人电话')" :maxlength="11"/>-->
              <base-phone-input v-model="formData.senderTelphone"
                                :maxlength="11"
                                :placeholder="$lang('请输入寄件人电话')"/>
            </el-form-item>
            <el-form-item :label="$lang('寄件省')" prop="senderProvinceName">
              <el-select v-model="formData.senderProvinceName" filterable @change="dataProvinceChange($event,1)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="(item.nativeName +'（'+ item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件城市')" prop="senderCityName">
              <el-select v-model="formData.senderCityName" filterable @change="dataCityChange($event,1)">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="(item.nativeName +'（'+ item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件地区')" prop="senderAreaName">
              <!-- <el-select v-model="formData.senderAreaName" @change="dataAreaChange($event,1)">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select> -->
              <el-autocomplete
                class="inline-input"
                popper-class="my-kqoption"
                v-model="formData.senderAreaName"
                :fetch-suggestions="querySearch"
                :popper-append-to-body="false"
                :placeholder="$lang('请输入')"
                value-key="enName"
                @blur="blurCity($event, 1)"
                @select="dataAreaChange($event, 1)"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item :label="$lang('寄件街道')" prop="senderStreet" style="width:360px;">
              <template slot="label"><span :title="$lang('寄件街道')">{{ $lang('寄件街道') }}</span></template>
              <el-input v-model="formData.senderStreet" :placeholder="$lang('请输入寄件街道')" :minlength="1" :maxlength="200"/>
              <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item>
            <!-- <el-form-item :label="$lang('寄件楼号')" prop="sendBuildingNo" style="width:100px;">
              <template slot="label"><span :title="$lang('寄件楼号')">{{ $lang('寄件楼号') }}</span></template>
              <el-input v-model="formData.sendBuildingNo" :placeholder="$lang('请输入楼号')" :minlength="1" :maxlength="5"/>
            </el-form-item>
            <el-form-item :label="$lang('寄件楼层')" prop="sendFloor">
              <template slot="label"><span :title="$lang('寄件楼层')">{{ $lang('寄件楼层') }}</span></template>
              <el-input v-model="formData.sendFloor" :placeholder="$lang('请输入楼层')" :minlength="1" :maxlength="5"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('寄件房号')" prop="sendRoomNumber" style="width:360px;">
              <template slot="label"><span :title="$lang('寄件房号')">{{ $lang('寄件房号') }}</span></template>
              <el-input v-model="formData.sendRoomNumber" :placeholder="$lang('请输入房号')" :minlength="1" :maxlength="5"></el-input>
              <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('寄件备注')" prop="sendRemark">
               <template slot="label"><span :title="$lang('寄件备注')">{{$lang('寄件备注')}}</span></template>
               <el-input class="sendRemarkStyle" v-model="formData.sendRemark" :placeholder="$lang('请输入备注')"  :minlength="1"  :maxlength="500"></el-input>
               <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
            </el-form-item> -->
            <!-- <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址')" prop="senderDetailedAddress">
                <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1"  :maxlength="80" ></el-input>
                <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
            </el-form-item> -->
          </div>
        </el-col>
        <el-col :span="12">
          <h3>{{ $lang('收件人信息') }}</h3>
          <div class="group-content">

            <el-form-item :label="$lang('收件人姓名')" prop="receiverName">
              <el-autocomplete
                :maxlength="50"
                valueKey="name"
                v-model="formData.receiverName"
                @select="changeReceiverName"
                :fetch-suggestions="remoteReceiverName"
                :placeholder="$lang('请输入收件人姓名')">
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(2)"></i>
                </template>
              </el-autocomplete>
            </el-form-item>
            <!-- <el-form-item :label="$lang('电话区号')" class="el-form-item w80 el-form-item--small" id="areaCodeSty">
               <template slot="label"><span :title="$lang('电话区号')">{{$lang('电话区号')}}</span></template>
               <el-input v-model="formData.receiverPhoneAreacode" :disabled="true"></el-input>
            </el-form-item> -->
            <el-form-item :label="$lang('收件人电话')" prop="receiverMobilePhone">
              <!--              <template slot="label"><span :title="$lang('收件人电话')">{{ $lang('收件人电话') }}</span></template>-->
              <!-- <el-input v-model="formData.receiverMobilePhone" :maxlength='15'  :placeholder="$lang('请输入收件人手机电话')"></el-input> -->
              <!--              <el-autocomplete
                              :maxlength="11"
                              valueKey="mobile"
                              @select="changeReceiverName"
                              v-model="formData.receiverMobilePhone"
                              :fetch-suggestions="remoteReceiverMobilePhone"
                              :placeholder="$lang('请输入收件人电话')">
                            </el-autocomplete>-->
              <base-phone-input v-model="formData.receiverMobilePhone" :maxlength="11" :placeholder="$lang('请输入寄件人电话')"/>
            </el-form-item>
            <el-form-item :label="$lang('收件人电话') + '2'" prop="receiverTelphone">
              <!--              <el-input v-model="formData.receiverTelphone" :placeholder="$lang('请输入收件人电话')" :maxlength="11"/>-->
              <base-phone-input v-model="formData.receiverTelphone" :maxlength="11" :placeholder="$lang('请输入收件人电话')"/>
            </el-form-item>
            <el-form-item :label="$lang('收件省')" prop="receiverProvinceName">
              <el-select v-model="formData.receiverProvinceName" filterable @change="dataProvinceChange($event,2)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="(item.nativeName +'（'+ item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件城市')" prop="receiverCityName">
              <el-select v-model="formData.receiverCityName" filterable @change="dataCityChange($event,2)">
                <el-option
                  v-for="item in cityList2"
                  :key="item.id"
                  :label="(item.nativeName +'（'+ item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件地区')" prop="receiverAreaName">
              <!-- <el-select v-model="formData.receiverAreaName" @change="dataAreaChange($event,2)">
                <el-option
                  v-for="item in areaList2"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select> -->
              <el-autocomplete
                class="inline-input"
                popper-class="my-kqoption"
                v-model="formData.receiverAreaName"
                :popper-append-to-body="false"
                :fetch-suggestions="querySearch2"
                :placeholder="$lang('请输入')"
                value-key="enName"
                @blur="blurCity($event, 2)"
                @select="dataAreaChange($event, 2)"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item :label="$lang('收件街道')" prop="receiverStreet" style="width:360px;">
              <template slot="label"><span :title="$lang('收件街道')">{{ $lang('收件街道') }}</span></template>
              <el-input v-model="formData.receiverStreet" :placeholder="$lang('请输入街道')" :minlength="1" :maxlength="500"/>
              <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item>
            <!-- <el-form-item :label="$lang('收件楼号')" prop="receiverBuildingNo" style="width:100px;">
              <template slot="label"><span :title="$lang('收件楼号')">{{ $lang('收件楼号') }}</span></template>
              <el-input v-model="formData.receiverBuildingNo" :placeholder="$lang('请输入楼号')" :minlength="1" :maxlength="5"/>
            </el-form-item>
            <el-form-item :label="$lang('收件楼层')" prop="receiverFloor" id="areaCodeSty">
              <template slot="label"><span :title="$lang('收件楼层')">{{ $lang('收件楼层') }}</span></template>
              <el-input v-model="formData.receiverFloor" :placeholder="$lang('请输入楼层')" :minlength="1" :maxlength="5"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件房号')" prop="receiverRoomNumber" id="areaCodeSty" style="width:360px;">
              <template slot="label"><span :title="$lang('收件房号')">{{ $lang('收件房号') }}</span></template>
              <el-input v-model="formData.receiverRoomNumber" :placeholder="$lang('请输入房号')" :minlength="1" :maxlength="5"></el-input>
              <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('派件备注')" prop="receiverRemark" id="areaCodeSty">
               <template slot="label"><span :title="$lang('派件备注')">{{$lang('派件备注')}}</span></template>
               <el-input class="sendRemarkStyle" v-model="formData.receiverRemark" :placeholder="$lang('请输入备注')"  :minlength="1"  :maxlength="500"></el-input>
               <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
            </el-form-item> -->
            <!-- <el-form-item class="el-form-item el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
                <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')"  :minlength="1"  :maxlength="80"></el-input>
                <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
            </el-form-item> -->
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <h3>{{ $lang('货物信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
              <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1" :maxlength="35"></el-input>
            </el-form-item>

            <el-form-item :label="$lang('物品类型')" prop="goods" ref="goods">
              <Base-Select v-model="formData.goods" :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')">
              </Base-Select>
            </el-form-item>

            <el-form-item :label="$lang('物品名称')" prop="goodsName">
              <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="20"></el-input>
            </el-form-item>

            <el-form-item :label="$lang('物品重量(kg)')" prop="packageTotalWeight">
              <el-input-number v-model="formData.packageTotalWeight" :label="$lang('描述文字')" :precision="2" :min="0" :max="999.99"></el-input-number>
            </el-form-item>

            <el-form-item :label="$lang('客户拣货数量')" prop="customerPickNumber">
              <el-input-number v-model="formData.customerPickNumber" :label="$lang('描述文字')" step-strictly :min="1" :max="999"></el-input-number>
            </el-form-item>

            <!-- <el-form-item :label="$lang('尺寸(cm)')" prop="packageNumber" class="sizeSty">
              {{ $lang('长') + '\xa0' }}
              <el-input v-model="formData.packageLength" :placeholder="$lang('请输入')" :minlength="1" :maxlength="3" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              {{ '\xa0\xa0' }}
              {{ $lang('宽') + '\xa0' }}
              <el-input v-model="formData.packageWide" :placeholder="$lang('请输入')" :minlength="1" :maxlength="3" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              {{ '\xa0\xa0' }}
              {{ $lang('高') + '\xa0' }}
              <el-input v-model="formData.packageHigh" :placeholder="$lang('请输入')" :minlength="1" :maxlength="3" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              {{ '\xa0\xa0' }}
            </el-form-item> -->

            <el-form-item :label="$lang('结算方式')" prop="payment">
              <Base-Select v-model="formData.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')" @getNetDicData="getNetDicData" :disabled="true" v-if="isReload">
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('支付方式')" prop="paidMode">
              <Base-Select v-model="formData.paidMode" :props="{label:'name',value:'code', res:'appPayTypeVOList',valueObj:true}" v-if="isReload" :disabled="paidOption"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')" @getNetDicData="getNetDicData2">
              </Base-Select>
            </el-form-item>

            <!-- 0510新增快递类型 -->
            <el-form-item :label="$lang('快递类型')" prop="expressType">
              <Base-Select v-model="formData.expressType" :props="{label:'name',value:'code', res:'appProductTypeVOList',valueObj:true}"
                           dicUrl="/vip/baseData/availableProductlist" :placeholder="$lang('请选择')" @getNetDicData="expressTypeData">
              </Base-Select>
            </el-form-item>

            <el-form-item :label="$lang('参考运费')" prop="standardValue">
              <el-input v-model="formData.standardValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('箱材规格')" prop="boxStandard">
                <Base-Select v-model="formData.boxStandard"
                    :props="{label:'name',value:'id', res:'records',valueObj:true}"
                    dicUrl="/vip/material/getMaterialSalesPrice"
                    :placeholder="$lang('请选择')">
                </Base-Select>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('箱材数量')" prop="boxNumber">
                 <el-input-number v-model="formData.boxNumber" label="描述文字" :step="1" :precision="0" :min="0" :max="99"></el-input-number>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('箱材单价')" prop="boxPrice">
                 <el-input v-model="formData.boxPrice" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
                <template slot="label"> <span :title="$lang('客户订单号')">{{$lang('客户订单号')}}</span></template>
            <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="50"></el-input>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('代收货款币别')" prop="boxPrice">
              <el-select v-model="formData.senderProvinceName">
                <el-option>DHS</el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('平台')" prop="platformName">
              <el-input v-model.trim="formData.platformName" :placeholder="$lang('请输入电商平台名称')" :minlength="1"  :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('客户账号')" prop="customerAccount">
              <el-input class="customerStyle" v-model.trim="formData.customerAccount" :placeholder="$lang('请输入电商平台客户账号')" :minlength="1"  :maxlength="10"></el-input>
            </el-form-item> -->
            <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
              <el-select v-model="formData.codCurrencyTypeName">
                <el-option
                  v-for="item in codCurrencyType"
                  :key="item.codCurrencyTypeCode"
                  :label="item.codCurrencyTypeName"
                  :value="item.codCurrencyTypeCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
              <el-input v-model="formData.codMoney" :disabled="codOption" :label="$lang('描述文字')" :placeholder="$lang('请输入对应的金额')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('代收货款手续费')" prop="codFee">
              <el-input v-model="formData.codFee" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12" :disabled="true"></el-input>
            </el-form-item>
            <!-- isOpenFod为1是已开通fod -->
            <el-form-item v-if="userInfo.isOpenFod === 1" :label="$lang('到付运费金额')" prop="fodMoney">
              <el-input v-model="formData.fodMoney" :placeholder="$lang('请输入')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
              <!-- <a class="btn-insured" @click="openInsured">{{$lang('保价声明')}}</a> -->
              <Base-Select :clearable="false" v-model="formData.insured" :dic="insuredDic" :placeholder="$lang('请选择')" @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('保险价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
              <el-input-number ref="declaredValueNumber" v-model="formData.declaredValue" @input.native="declaredValueInput()" :placeholder="$lang('请输入')" :step="1" :precision="2" :controls="false" :min="0" :max="100000"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured===1">
              <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="">
              <div class="isSigndan" v-if="isSignFlag">
                <el-checkbox v-model="checked" :disabled="hdFlag"></el-checkbox>
                <div class="tit">{{ $lang('是否有回单') }}</div>
              </div>
            </el-form-item>
            <!-- 是否签回单 -->
            <!-- <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
               <template slot="label"> <span :title="$lang('是否签回单')">{{$lang('是否签回单')}}</span></template>
               <Base-Select :clearable="false"
                v-model="formData.signReceipt"
                :dic="signReceiptDic"
                :disabled="formData.paymentModeName === 'PP_PM' "
                :placeholder="$lang('请选择')"
                @change="changeSignReceipt"
                :props="{label:'name' ,value:'code'}">
                </Base-Select>
           </el-form-item>
           <el-form-item :label="$lang('回单管理费')" prop="receiptFreight" v-show="formData.signReceipt===1">
               <el-input v-model="formData.receiptFreight" :disabled="true"></el-input>
           </el-form-item> -->
            <!-- <el-form-item :label="$lang('下单数量')" >
                <el-input-number v-model="formData" :min="1" :max="99"></el-input-number>
            </el-form-item> -->
            <br>
            <el-form-item v-if="formData.expressTypeCode === 'EX' || formData.expressTypeCode === 'DR'" :label="$lang('Ex/DR描述')" prop="exdrDescription" class="el-form-item el-form-item--small" style="width:33%">
              <el-input v-model="formData.exdrDescription" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="500" resize="none"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('客户拣货信息')" prop="customerPickInfo" class="el-form-item el-form-item--small" style="width:33%">
              <el-input v-model="formData.customerPickInfo" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="500" resize="none"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('备注')" prop="remarks" class="el-form-item el-form-item--small" style="width:33%">
              <el-input v-model="formData.remarks" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="500" resize="none"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

    </el-form>
    <div class="bc-bottom">
      <el-button type="primary" @click="saveSubmit('sizeForm')" :loading="keyBtn" class="h48">{{ $lang('立即下单') }}</el-button>
    </div>
    <SmartSpot v-model="smartSpot"></SmartSpot>
    <AddressBook v-model="addrBook" :selectType="selectType" @single-row-select="singleRowSelect" ref='address'></AddressBook>
    <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>

  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import { RESPONSE_SUCCESS } from '@constants'
import { RULES, phoneAndMobile, integerWeight, checkGoodsName, isName } from '@/utils/rules'
import { DIC } from '@constants'
import SmartSpot from './SmartSpot'
import AddressBook from './AddressBook'
import {
  vipOrderAdd,
  receiptOrder,
  reqAddressList,
  getComCost,
  getSettlement,
  getComputationCost,
  getDefaultAddress,
  printOrders,
  getReceiptFee,
  queryAddressAnalysisAddress,
  getsysCurrencyType,
  checkArea
} from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import * as Api from '@api/base/public'
import { getCalc } from '@api/module/customer'
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import BasePhoneInput from '@/components/base/BasePhoneInput'

export default {
  name: 'SingleOrder',
  provide() {
    return {
      reload: this.reload,
    }
  },
  components: {
    BasePhoneInput,
    SmartSpot,
    AddressBook,
    InsuredStatement,
  },
  data() {
    return {
      DIC,
      COM_HTTP: {
        reqAdd: vipOrderAdd,
      },
      countryCode: '+20',
      showClick: false,
      printOptions: {
        btnTitle: '下单并打印',
        btnType: 'primary',
        isHideIcon: true,
      },
      isReload: true,
      provinceArray: [],
      printOrder: false,
      keyBtn: false,
      keyBtn1: false,
      paidOption: true,
      codOption: false,
      getOrderId: '', // 获取下单并打印的订单id
      rules: {
        senderName: [RULES.required, { validator: isName }],
        senderMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        senderTelphone: [RULES.lengthEleven, { validator: phoneAndMobile }],
        senderProvinceName: [RULES.requiredSelect],
        senderCityName: [RULES.requiredSelect],
        senderAreaName: [RULES.requiredSelect],
        // codCurrencyTypeName: [RULES.requiredSelect],
        // sendBuildingNo: [RULES.requiredTrim],
        // senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        senderStreet: [RULES.requiredTrim],
        // codMoney: [RULES.required, { validator: isNull }],
        receiverName: [RULES.required, { validator: isName }],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverTelphone: [RULES.lengthEleven, { validator: phoneAndMobile }],
        receiverProvinceName: [RULES.requiredSelect],
        receiverCityName: [RULES.requiredSelect],
        receiverAreaName: [RULES.requiredSelect],
        // receiverBuildingNo: [RULES.requiredTrim],
        // receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        receiverStreet: [RULES.requiredTrim],
        // goods: [RULES.required],
        goodsName: [{ validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        // packageNumber: [RULES.required],
        payment: [RULES.requiredSelect],
        // paidMode: [RULES.requiredSelect],
        insured: [RULES.requiredSelect],
        expressType: [RULES.requiredSelect],
        customerOrderId: [RULES.twenty_num_strNew],
        exdrDescription: [RULES.required],
      },
      addrBook: false,
      smartSpot: false,
      infoVisible: false, // 保价费声明弹窗
      defaultFormData: {},
      checked: false,
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderTelphone: '', // 寄件人手机号2,
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        senderStreet: '', // 寄件街道,
        senderPhoneAreacode: '+20', // 寄件电话区号
        // senderPostalCode: '', // 寄件邮编
        // senderEmail: '', // 寄件邮箱
        senderProvince: '', // 寄件区省/市/区
        sendBuildingNo: '', // 寄件楼号
        sendFloor: '', // 寄件楼层
        sendRoomNumber: '', // 寄件房号
        sendRemark: '', // 寄件备注
        // senderDetailedAddress: '', // 寄件详细地址,
        receiverName: '', // 收件人姓名,
        receiverPhoneAreacode: '+20', // 收件电话区号
        receiverMobilePhone: '', // 收件人手机号,
        receiverTelphone: '', // 收件人手机号2,
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        receiverStreet: '', // 收件街道,
        receiverPostalCode: '', // 收件邮编
        receiverEmail: '', // 收件邮箱
        receiverProvince: '', // 收件区省/市/区
        receiverBuildingNo: '', // 收件楼号
        receiverFloor: '', // 收件楼层
        receiverRoomNumber: '', // 收件房号
        receiverRemark: '', // 收件备注
        // receiverDetailedAddress: '', // 收件详细地址,
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: '', // 保价费,
        goods: {
          id: 108,
          code: 'ITN4',
          name: 'Others'
        }, // 物品类型
        goodsTypeId: 108, // 物品类型id,
        goodsTypeCode: 'ITN4', // 物品类型编码,
        goodsTypeName: 'Others', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 1, // 物品重量,
        customerPickNumber: 1,
        packageNumber: 1, // 物品件数,
        packageLength: '', // 物品长,
        packageWide: '', // 物品宽,
        packageHigh: '', // 物品高,
        payment: {}, // 结算方式
        // payment: { code: 'PP_PM', name: this.$lang('Monthly'), id: 42 }, // 结算方式
        // payment: 'CC_CASH', // 结算方式
        paidMode: {}, // 支付方式
        paidModeCode: '', // 支付方式code
        paidModeName: '', // 支付方式名称
        paidModeId: '', // 支付方式id
        // paymentModeId: '42', // 结算方式id,
        // paymentModeCode: 'PP_PM', // 结算方式编码,
        // paymentModeName: this.$lang('Monthly'), // 结算方式名称,
        paymentModeId: '', // 结算方式id,
        paymentModeCode: '', // 结算方式编码,
        paymentModeName: '', // 结算方式名称,
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // 代收货款金额,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxNumber: 0, // 箱材数量,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        boxTotalPrice: 0, // 箱材总价,
        remarks: '', // 备注,
        customerPickInfo: '',
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量
        customerOrderId: '',
        senderCompany: '',
        receiverCompany: '',
        checkSenderFlag: '', // 寄件人保存至地址簿
        checkReceiverFlag: '', // 收件人保存至地址簿
        signReceipt: 0, // 签回单 0否 1是
        receiptFreight: 0, // 回单金额
        codCurrencyTypeName: 'EGP', // 代收货款币别
        codCurrencyTypeCode: 'EGP', // 代收货款币别code
        platformName: '', // 平台
        customerAccount: '', // 客户账号
        exdrDescription: '', // EX/DR描述
        fodMoney: '', // 到付运费金额
      },
      cityList: [],
      cityList2: [],
      areaList: [],
      areaList2: [],
      // codCurrencyType: [{ codCurrencyTypeCode: 'AED', codCurrencyTypeName: 'AED' }, { codCurrencyTypeCode: 'USD', codCurrencyTypeName: 'USD' }],
      codCurrencyType: [],
      receiptFreight: 0,
      checkSenderFlag: false,
      checkReceiverFlag: false,
      isSignFlag: false, // 是否展示回单checkbox
      initData: {
        url: '/oauth/sysRoleResource/getAppResources',
        type: 'app',
        leftText: this.$lang('未选权限'),
        rightText: this.$lang('已选权限'),
        rightOptText: this.$lang('全部权限'),
        exculdeIdsParam: 'resourceIds',
      },
      selectType: 1,
      hdFlag: false,
      sendAddressData: {
        formProps: {
          provinceIdProp: 'senderProvinceId',
          provinceNameProp: 'senderProvinceName',
          cityIdProp: 'senderCityId',
          cityNameProp: 'senderCityName',
          areaIdProp: 'senderAreaId',
          areaNameProp: 'senderAreaName',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'receiverProvinceId',
          provinceNameProp: 'receiverProvinceName',
          cityIdProp: 'receiverCityId',
          cityNameProp: 'receiverCityName',
          // areaIdProp: 'receiverAreaId',
          // areaNameProp: 'receiverStreet',
        },
        defaultData: {},
      },
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      signReceiptDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      // payTypesDic: [{ code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: this.$lang('寄付现结'), id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: this.$lang('到付现结'), id: 321, type: 'ZD106' }],
      payDefaultObj: {},
    }
  },

  created() {
    this.getProList()
    this.getCurrencyTypeList()
    this.fromType = this.comeFrom
    if (this.id) {
      this.getDetail()
    }
    if (this.formData.insured === 1) { // 是否保价1是，0否,
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
    // this.getReceiptFee() // 获取回单金额
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
  },
  watch: {
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = ''
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = ''
      }
    },
    // 结算方式
    async 'formData.payment'(val) {
      // console.log(val)
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
      if (val.code === 'CC_CASH') {
        this.paidOption = false
        this.codOption = true
        this.formData.codMoney = ''
      } else {
        this.paidOption = true
        this.codOption = false
        this.formData.paidMode = ''
      }
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvinceId, receiverProvinceId, packageTotalWeight } = this.formData
      if (senderProvinceId && receiverProvinceId && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持保价
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.formData.insuredValue = ''
        this.formData.receiptFreight = 0
      }
      console.log(this.formData)
    },
    // 支付方式
    async 'formData.paidMode'(val) {
      // debugger
      const { id: paidModeId, code: paidModeCode, name: paidModeName } = val
      Object.assign(this.formData, { paidModeId, paidModeCode, paidModeName })
      const { senderProvinceId, receiverProvinceId, packageTotalWeight } = this.formData
      if (senderProvinceId && receiverProvinceId && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      console.log(this.formData)
    },
    async 'formData.expressType'(val) {
      console.log(val, 'v____________')
      const { senderAreaName, packageTotalWeight, declaredValue, goods, insured } = this.formData
      const { code, name } = val
      this.$nextTick(() => {
        // 当快递类型为Standard 或 Premium，才可以选择回单；其他均不允许下回单
        this.hdFlag = !(code === 'PR' || code === 'EZ')
        if (this.hdFlag) this.checked = false
      })
      // 快递类型为DR时 cod禁用
      const obj = {
        'DR': () => { this.codOption = true; this.formData.codMoney = '' },
        'default': () => { this.codOption = false }
      }
      code === 'DR' ? obj[code]() : obj['default']()
      Object.assign(this.formData, { expressTypeCode: code, expressTypeName: name })
      if (senderAreaName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && val) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = ''
      }
    },
    // 运费计算
    async 'formData.senderAreaName'(val) {
      const { senderAreaName, packageTotalWeight, expressType } = this.formData
      if (expressType && senderAreaName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费计算
    async 'formData.receiverAreaName'(val) {
      const { receiverAreaName, packageTotalWeight, expressType } = this.formData
      if (expressType && receiverAreaName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费重量
    async 'formData.packageTotalWeight'(val) {
      const { senderAreaName, receiverAreaName } = this.formData
      if (senderAreaName && receiverAreaName && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 箱材规格计算
    async 'formData.boxStandard'(val) {
      const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res, {
        // 箱材规格id
        boxStandardId,
        // 箱材规格名称
        boxStandardName,
        // 箱材单价
        boxPrice,
      })
    },
    // 箱材数量
    async 'formData.boxNumber'(val) {
      const { boxStandardId, boxStandardName, boxPrice } = this.formData
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res)
    },
    // 保价费计算
    // async 'formData.declaredValue'(val) {
    //   console.log(val, 'val___________')
    //   const { goods, insured, expressTypeCode } = this.formData
    //   console.log(expressTypeCode, 'expressTypeCode_________')
    //   if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
    //     const res = await this.getComputationCost(this.formData)
    //     Object.assign(this.formData, { insuredValue: res })
    //   } else {
    //     this.formData.insuredValue = ''
    //   }
    // },
    'formData.fodMoney'(val) {
      const { fodMaxAmount } = this.userInfo
      if (fodMaxAmount && val > fodMaxAmount) {
        this.$message.error(`${this.$lang('到付运费金额不能超过')}${fodMaxAmount}! ${this.$lang('请重新输入')}`)
        this.formData.fodMoney = ''
        return
      } else if (parseFloat(val) > 99999) {
        this.$message.error(this.$lang('到付运费金额不能超过99999！请重新输入'))
        this.formData.fodMoney = ''
        return
      } else if (toString(val).indexOf('.') !== -1 && toString(val).split('.')[1].length > 2) {
        this.$message.error(this.$lang('到付运费金额不能超过2位小数！请重新输入'))
        this.formData.fodMoney = ''
        return
      }
    },
    // 代收货款手续费计算
    async 'formData.codMoney'(val) {
      // debugger
      const { codMoney } = this.formData
      const { codMaxAmount, isOpenCod } = this.userInfo
      if (parseFloat(codMoney) > 0) {
        if (isOpenCod === 2) {
          this.$message.error(this.$lang(`未开通COD`))
          this.formData.codMoney = ''
          return
        } else if (parseFloat(codMoney) > codMaxAmount) {
          this.$message.error(`${this.$lang('代收货款不能超过')}${codMaxAmount}! ${this.$lang('请重新输入')}`)
          this.formData.codMoney = ''
          return
        } else if (parseFloat(codMoney) > 99999.9) {
          this.$message.error(this.$lang('代收货款不能超过99999.9！请重新输入'))
          this.formData.codMoney = ''
          return
        } else if (toString(codMoney).indexOf('.') !== -1 && codMoney.split('.').length > 2) {
          this.$message.error(this.$lang('代收货款不能有多个小数点！请重新输入'))
          this.formData.codMoney = ''
          return
        } else if (toString(codMoney).indexOf('.') !== -1 && codMoney.split('.')[1].length > 1) {
          this.$message.error(this.$lang('代收货款不能超过一位小数！请重新输入'))
          this.formData.codMoney = ''
          return
        }
        const codFeeParam = { collectionfee: codMoney }
        const res = await getCalc(codFeeParam)
        Object.assign(this.formData, { codFee: (res.data !== undefined && res.data !== null ? res.data : 0) })
      } else {
        this.formData.codMoney = ''
        this.formData.codFee = ''
      }
    },
    // 长
    async 'formData.packageLength'(val) {
      const { packageLength } = this.formData
      if (parseFloat(packageLength) <= 0) {
        this.formData.packageLength = ''
        return
      }
    },
    // 宽
    async 'formData.packageWide'(val) {
      const { packageWide } = this.formData
      if (parseFloat(packageWide) <= 0) {
        this.formData.packageWide = ''
        return
      }
    },
    // 高
    async 'formData.packageHigh'(val) {
      const { packageHigh } = this.formData
      if (parseFloat(packageHigh) <= 0) {
        this.formData.packageHigh = ''
        return
      }
    },
    // async 'formData.senderMobilePhone' (val) {
    //   console.log(val)
    //   if (val && !val.startsWith('+')) {
    //     this.formData.senderMobilePhone = '+' + this.formData.senderMobilePhone
    //   }
    // },
    // 'formData.receiverMobilePhone': {
    //   handler (val) {
    //     console.log(val)
    //     if (val && !val.startsWith('+')) {
    //       this.formData.receiverMobilePhone = '+' + this.formData.receiverMobilePhone
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  mounted() {
    // 寄件人默认信息
    this.getDefaultAddress({ type: 1 })
    // 收件人默认信息
    this.getDefaultAddress({ type: 2 })
  },
  methods: {
    ...mapActions(['UPDATE_PRINT_STOCK']),
    // 保价费计算
    declaredValueInput: debounce(async function (e) {
      const val = this.$refs.declaredValueNumber.displayValue
      const { goods, insured, expressTypeCode } = this.formData
      this.formData.declaredValue = val
      if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = ''
      }
    }, 300),
    getNetDicData(data, type) {
      console.log(data, type)
      if (type === 'appPaymentMannerVOList') {
        const payObj = data.find(item => item.code === this.userInfo.settlementCode)
        if (payObj && Object.keys(payObj).length) {
          this.payDefaultObj = payObj
          this.formData.payment = payObj
          this.formData.paymentModeId = payObj.id
          this.formData.paymentModeCode = payObj.code
          this.formData.paymentModeName = payObj.name
        }
      }
    },
    getNetDicData2(data, type) {
      console.log(data, type)
      if (type === 'appPayTypeVOList') {
        const { paidModeId, paidModeCode, paidModeName } = this.userInfo
        Object.assign(this.formData, { paidModeId, paidModeCode, paidModeName }, {
          paidMode: {
            id: paidModeId,
            name: paidModeName,
            code: paidModeCode
          }
        })
      }
    },
    expressTypeData(data, type, result) {
      console.log(result, 'result')
      if (result) {
        this.isSignFlag = true
      } else {
        this.isSignFlag = false
      }
    },
    beforePrint() {
      const userInfo = this.userInfo
      if (userInfo.surfaceFormat === 1) {
        this.$alert(this.$lang('请先到我的资料里设置面单格式'), this.$lang('提示'), {
          confirmButtonText: this.$lang('确定'),
        })
        return
      } else {
        this.printOrder = true
        this.saveSubmit('sizeForm')
      }
    },
    reload() {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    },
    // 获取打印数据
    async getPrintData(type) {
      const ids = [this.getOrderId]
      const params = { ids: ids, printType: type, isVip: true }
      const { code, msg, data } = await printOrders(params)
      if (code === 1) {
        if (data.length) this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        this.printOrder = false
        setTimeout(() => {
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return data || []
      } else {
        this.$message.error(this.$lang(msg))
        return []
      }
    },
    // 获取省数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
        console.log(this.provinceArray)
      } else {
        this.$message.error(msg)
      }
    },

    // 获取币别  sysCurrencyType/list
    async getCurrencyTypeList() {
      const { data, code, msg } = await getsysCurrencyType()
      // debugger
      var dataList = []
      if (code === RESPONSE_SUCCESS) {
        for (let p = 0; p < data.length; p++) {
          dataList.push({ codCurrencyTypeCode: data[p].code, codCurrencyTypeName: data[p].enName })
        }
        // console.log(dataList)
        this.codCurrencyType = dataList
      } else {
        this.$message.error(msg)
      }
    },

    dataProvinceChange(value, flag) {
      console.log(value)
      this.getCityList(value, flag)
    },

    dataCityChange(value, num) {
      console.log(value)
      // debugger
      if (num === 1) {
        this.formData.senderCityId = value
        const obj = this.cityList.find((item) => {
          return item.id === value
        })
        this.formData.senderCityName = obj.nativeName + '（' + obj.enName + '）'
        this.getAreaList(value, num)
      } else {
        this.formData.receiverCityId = value
        const obj = this.cityList2.find((item) => {
          return item.id === value
        })
        this.formData.receiverCityName = obj.nativeName + '（' + obj.enName + '）'
        this.getAreaList(value, num)
      }
    },

    dataAreaChange(value, num) {
      // debugger
      if (num === 1) {
        this.formData.senderAreaId = value.id
        const obj = this.areaList.find((item) => {
          return item.id === value.id
        })
        this.formData.senderAreaName = obj.nativeName + '（' + obj.enName + '）'
      } else {
        this.formData.receiverAreaId = value.id
        const obj = this.areaList2.find((item) => {
          return item.id === value.id
        })
        this.formData.receiverAreaName = obj.nativeName + '（' + obj.enName + '）'
      }
    },

    // 获取区域数据
    async getAreaList(parentId, flag) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        if (flag === 1) {
          this.areaList = data
          this.formData.senderCityId = parentId
          this.formData.senderAreaId = ''
          this.formData.senderAreaName = ''
          // this.formData.senderAreaId = data[0].id
          // this.formData.senderAreaName = data[0].nativeName + '（' + data[0].enName + '）'
          let obj = {}
          obj = this.cityList.find((item) => {
            return item.id === parentId
          })
          this.formData.senderCityName = obj.nativeName + '（' + obj.enName + '）'
        } else if (flag === 2) {
          this.areaList2 = data
          this.formData.receiverCityId = parentId
          this.formData.receiverAreaId = ''
          this.formData.receiverAreaName = ''
          // this.formData.receiverAreaId = data[0].id
          // this.formData.receiverAreaName = data[0].nativeName + '（' + data[0].enName + '）'
          let obj = {}
          obj = this.cityList2.find((item) => {
            return item.id === parentId
          })
          this.formData.receiverCityName = obj.nativeName + '（' + obj.enName + '）'
        }
      } else {
        this.$message.error(msg)
      }
    },
    blurCity(val, type) {
      console.log(val.target.value, type)
      if (type === 1) {
        const hasCity = this.areaList.find(item => item.nativeName === val.target.value)
        hasCity ? this.formData.senderAreaId = hasCity.id : this.formData.senderAreaId = ''
        console.log('1----------------', val.target.value, hasCity)
      } else {
        const hasCity = this.areaList2.find(item => item.nativeName === val.target.value)
        hasCity ? this.formData.receiverAreaId = hasCity.id : this.formData.receiverAreaId = ''
        console.log('2----------------', val.target.value, hasCity)
      }
    },
    querySearch(queryString, cb) {
      var restaurants = cloneDeep(this.areaList)
      console.log(queryString)
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter2(queryString)) : restaurants
      var listPam = []
      if (results.length > 0) {
        results.forEach((item) => {
          listPam.push(Object.assign(item, { enName: (item.nativeName + '（' + item.enName + '）') }))
        })
      }
      console.log('llllllll', results)
      // 调用 callback 返回建议列表的数据
      cb(listPam)
    },
    querySearch2(queryString, cb) {
      // var restaurants = this.areaList2
      var restaurants = cloneDeep(this.areaList2)
      console.log(queryString)
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter2(queryString)) : restaurants
      var listPam = []
      if (results.length > 0) {
        results.forEach((item) => {
          listPam.push(Object.assign(item, { enName: (item.nativeName + '（' + item.enName + '）') }))
        })
      }
      console.log('llllllll', results)
      // 调用 callback 返回建议列表的数据
      cb(listPam)
    },
    createFilter2(queryString) {
      return (restaurant) => {
        var restaurantVal = restaurant.nativeName + '（' + restaurant.enName + '）'
        return (restaurantVal.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    // 获取城市数据
    async getCityList(parentId, flag) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        if (flag === 1) {
          this.cityList = data
          this.formData.senderProvinceId = parentId
          this.formData.senderCityId = ''
          this.formData.senderCityName = ''
          this.formData.senderAreaId = ''
          this.formData.senderAreaName = ''
          // this.formData.senderCityId = data[0].id
          // this.formData.senderCityName = data[0].nativeName + '（' + data[0].enName + '）'
          // this.getAreaList(data[0].id, flag)
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.formData.senderProvinceName = obj.nativeName + '（' + obj.enName + '）'
        } else if (flag === 2) {
          this.cityList2 = data
          this.formData.receiverProvinceId = parentId
          this.formData.receiverCityId = ''
          this.formData.receiverCityName = ''
          this.formData.receiverAreaId = ''
          this.formData.receiverAreaName = ''
          // this.formData.receiverCityId = data[0].id
          // this.formData.receiverCityName = data[0].nativeName + '（' + data[0].enName + '）'
          // this.getAreaList(data[0].id, flag)
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.formData.receiverProvinceName = obj.nativeName + '（' + obj.enName + '）'
        }
      } else {
        this.$message.error(msg)
      }
    },
    // // 获取打印数据
    // async getPrintData(type) {
    //   return [this.formData]
    // },
    discern(type) {
      let text
      switch (type) {
        case 0:
          if (!this.formData.analysisAddress) {
            return
          }
          text = this.formData.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  senderName: person,
                  senderMobilePhone: phonenum,
                  senderDetailedAddress: detail,
                  senderProvince: {
                    senderProvinceName: province,
                    senderProvinceId: provinceCode,
                    senderCityId: cityCode,
                    senderCityName: city,
                    senderAreaId: countyCode,
                    senderAreaName: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.formData.analysisAddress = ''
          break
        case 2:
          if (!this.formData.analysisAddress1) {
            return
          }
          text = this.formData.analysisAddress1
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  receiverName: person,
                  receiverMobilePhone: phonenum,
                  receiverDetailedAddress: detail,
                  receiverProvince: {
                    receiverProvinceName: province,
                    receiverProvinceId: provinceCode,
                    receiverCityId: cityCode,
                    receiverCityName: city,
                    receiverAreaId: countyCode,
                    receiverStreet: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 3:
          this.formData.analysisAddress1 = ''
          break
        default:
          break
      }
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    // 运费计算
    async calcStandardCost(data) {
      const { senderProvinceId, senderCityId, senderAreaId, receiverCityId, receiverProvinceId, receiverAreaId, packageTotalWeight, paymentModeId, expressTypeCode } = this.formData
      const promises = [
        // 获取起始地址ID
        this.getSettlement(senderProvinceId, senderCityId, senderAreaId),
        // 获取目的地地址ID
        this.getSettlement(receiverProvinceId, receiverCityId, receiverAreaId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 运费
      const obj = {}
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId) {
        // 获取运费
        const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
      }
      // 返回结果
      return {
        // ...result,
        ...obj,
      }
    },
    // 获取默认地址
    async getDefaultAddress(param) {
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          this.singleRowSelect(data, param.type)
        }
        // this.defaultFormData = commonFun.deepClone(this.formData)
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 箱材规格计算
    async calcBoxStandard({ boxStandardId, boxStandardName, boxPrice } = {}) {
      const { boxNumber } = this.formData
      // 箱数量
      const boxTotalPrice = this.$common.floatNumSub(boxNumber ? boxNumber * boxPrice : 0)
      return {
        // 箱材总价格
        boxTotalPrice,
      }
    },
    // 打开地址
    open(selectType) {
      this.addrBook = true
      this.selectType = selectType
      const data = selectType === 1 ? this.curentSend : this.curentReceiver
      this.$refs.address.updateBtnStauts(data)
      this.$refs.address.initData()
    },
    singleRowSelect(data, type) {
      if (!data.cityId) {
        return
      }
      const { name, mobile, detailedAddress, companyName, buildingNo, buildingFloor, roomNumber, alternateMobile } = data
      if (type === 1) { // 1寄件2取件
        this.formData.senderName = name // 寄件人姓名,
        this.formData.senderMobilePhone = this.filterPhone(mobile) // 寄件人手机号
        this.formData.senderTelphone = this.filterPhone(alternateMobile) // 寄件人手机号
        this.formData.senderDetailedAddress = detailedAddress // 寄件详细地址
        this.formData.sendBuildingNo = buildingNo // 楼号
        this.formData.sendFloor = buildingFloor // 楼层
        this.formData.sendRoomNumber = roomNumber // 房号
        this.formData.senderCompany = companyName
        this.curentSend = data
        this.handleProvice(data, type)
      } else if (type === 2) {
        this.formData.receiverName = name // 收件人姓名,
        this.formData.receiverMobilePhone = this.filterPhone(mobile) // 收件人手机号
        this.formData.receiverTelphone = this.filterPhone(alternateMobile) // 收件人手机号
        this.formData.receiverDetailedAddress = detailedAddress // 收件详细地址
        this.formData.receiverBuildingNo = buildingNo // 楼号
        this.formData.receiverFloor = buildingFloor // 楼层
        this.formData.receiverRoomNumber = roomNumber // 房号
        this.formData.receiverCompany = companyName
        this.curentReceiver = data
        this.handleProvice(data, type)
      }
    },
    filterPhone(val) {
      if (!val) return ''
      if (val.indexOf('+') !== -1) {
        return val
      } else {
        return '+20-' + val
      }
    },
    /**
     * 是否保价
     */
    changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.declaredValue = ''
        this.formData.insuredValue = ''
      }
    },
    /**
     * 是否签回单
     */
    changeSignReceipt(val) {
      if (val === 0) {
        this.formData.receiptFreight = 0
      } else if (val === 1) {
        this.formData.receiptFreight = this.receiptFreight
      }
    },
    // 收件人姓名或者电话改变
    async changeReceiverName(item) {
      const Exit = await this.checkArea(item)
      if (!Exit) {
        return
      }
      this.formData.receiverName = item.name
      this.formData.receiverMobilePhone = item.mobile
      this.formData.receiverTelphone = item.alternateMobile
      this.formData.receiverCompany = item.companyName
      this.formData.receiverDetailedAddress = item.detailedAddress
      this.singleRowSelect(item, 2)
    },
    // 寄件人姓名或者电话改变
    async changeSenderName(item) {
      const Exit = await this.checkArea(item)
      if (!Exit) {
        return
      }
      this.formData.senderName = item.name
      this.formData.senderMobilePhone = item.mobile
      this.formData.senderTelphone = item.alternateMobile
      this.formData.senderCompany = item.companyName
      this.formData.senderDetailedAddress = item.detailedAddress
      this.singleRowSelect(item, 1)
    },
    // 字符串截取
    newStr(str) {
      if (str.indexOf('（') !== -1) {
        return str.substring(0, str.indexOf('（'))
      } else {
        return str
      }
    },
    // 表单保存  立即下单
    async saveSubmit(formName) {
      console.log(this.formData)
      const { insured, declaredValue, codMoney } = this.formData
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持保价'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('保险价值必须大于0'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.insuredValue && this.formData.insuredValue !== 0)) {
        this.$message.error(this.$lang('未找到保价费报价'))
        return
      }
      if (insured === 1 && codMoney && (declaredValue > +codMoney)) {
        this.$message.error(this.$lang(`Your insurance value shouldn't be higher than the COD amount.`))
        return
      }
      // debugger
      // if (this.formData.codCurrencyTypeName === 'USD') {
      //   this.formData.codCurrencyTypeCode = 'USD'
      // } else {
      //   this.formData.codCurrencyTypeCode = 'AED'
      // }
      this.codCurrencyType.map((item) => {
        if (this.formData.codCurrencyTypeName === item.codCurrencyTypeName) {
          this.formData.codCurrencyTypeCode = item.codCurrencyTypeCode
        }
      })
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.printOrder) {
            this.keyBtn1 = true
          } else {
            this.keyBtn = true
          }
          if (this.formData.insured === 0) this.formData.declaredValue = ''
          this.formData.packageChargeWeight = this.formData.packageTotalWeight
          this.formData.boxStandardCode = this.formData.boxStandard ? this.formData.boxStandard.code : ''
          this.formData.boxNumber = this.formData.boxStandard ? this.formData.boxNumber : null
          this.formData.checkReceiverFlag = this.checkReceiverFlag ? 1 : 0
          this.formData.checkSenderFlag = this.checkSenderFlag ? 1 : 0
          var formParams = Object.assign({}, this.formData)
          formParams.senderProvinceName = this.newStr(formParams.senderProvinceName)
          formParams.senderCityName = this.newStr(formParams.senderCityName)
          formParams.senderAreaName = this.newStr(formParams.senderAreaName)
          formParams.receiverProvinceName = this.newStr(formParams.receiverProvinceName)
          formParams.receiverCityName = this.newStr(formParams.receiverCityName)
          formParams.receiverAreaName = this.newStr(formParams.receiverAreaName)
          // var formParams = Object.assign({}, this.formData)
          // formParams.senderProvinceName = formParams.senderProvinceName.substring(0, formParams.senderProvinceName.indexOf('（'))
          // formParams.senderCityName = formParams.senderCityName.substring(0, formParams.senderCityName.indexOf('（'))
          // formParams.senderAreaName = formParams.senderAreaName.substring(0, formParams.senderAreaName.indexOf('（'))
          // formParams.receiverProvinceName = formParams.receiverProvinceName.substring(0, formParams.receiverProvinceName.indexOf('（'))
          // formParams.receiverCityName = formParams.receiverCityName.substring(0, formParams.receiverCityName.indexOf('（'))
          // formParams.receiverAreaName = formParams.receiverAreaName.substring(0, formParams.receiverAreaName.indexOf('（'))
          this.checked ? this.receiptOrderAdd(formParams) : this.vipOrderAdd(formParams)
        } else {
          return false
        }
      })
    },
    async receiptOrderAdd(reqData) {
      try {
        const resData = await receiptOrder(reqData)
        if (resData.code === RESPONSE_SUCCESS) {
          this.getOrderId = resData.data.id
          this.$message({
            message: this.$lang('下单成功！'),
            type: 'success',
          })

          if (this.printOrder) {
            const userInfo = this.userInfo
            const value = userInfo.surfaceFormat === 2 ? 'oneLinkPage' : 'twoLinkPage'
            this.$refs.print.toPrint(value)
            this.keyBtn1 = false
          } else {
            this.keyBtn = false
          }
          this.formData.packageLength = ''
          this.formData.packageWide = ''
          this.formData.packageHigh = ''
          this.$refs.sizeForm.resetFields()
          this.checkSenderFlag = false
          this.checkReceiverFlag = false
          this.checked = false
          // 寄件人默认信息
          this.getDefaultAddress({ type: 1 })
          // 收件人默认信息
          this.getDefaultAddress({ type: 2 })
          this.reload()
          this.$router.push({ path: 'redirect/singleOrder' })
          this.formData.senderPostalCode = ''
          this.formData.senderEmail = ''
          this.formData.receiverPostalCode = ''
          this.formData.receiverEmail = ''
        } else {
          this.formData.packageLength = ''
          this.formData.packageWide = ''
          this.formData.packageHigh = ''
          this.$message.error(resData.msg)
          this.keyBtn = false
        }
      } catch (error) {
        this.keyBtn1 = false
        this.keyBtn = false
      }
    },
    async vipOrderAdd(reqData) { // 新增订单
      try {
        const resData = await vipOrderAdd(reqData)
        if (resData.code === RESPONSE_SUCCESS) {
          this.getOrderId = resData.data.id
          this.$message({
            message: this.$lang('下单成功！'),
            type: 'success',
          })
          if (this.printOrder) {
            const userInfo = this.userInfo
            const value = userInfo.surfaceFormat === 2 ? 'oneLinkPage' : 'twoLinkPage'
            this.$refs.print.toPrint(value)
            this.keyBtn1 = false
          } else {
            this.keyBtn = false
          }

          // this.formData = commonFun.deepClone(this.defaultFormData)
          this.formData.packageLength = ''
          this.formData.packageWide = ''
          this.formData.packageHigh = ''
          this.$refs.sizeForm.resetFields()
          this.checkSenderFlag = false
          this.checkReceiverFlag = false
          // 寄件人默认信息
          this.getDefaultAddress({ type: 1 })
          // 收件人默认信息
          this.getDefaultAddress({ type: 2 })
          this.reload()
          this.$router.push({ path: 'redirect/singleOrder' })
          this.formData.senderPostalCode = ''
          this.formData.senderEmail = ''
          this.formData.receiverPostalCode = ''
          this.formData.receiverEmail = ''
        } else if (resData.code === 149010023) {
          this.$message.warning(resData.msg)
          this.formData.senderProvinceId = ''// 收件省份id,
          this.formData.senderProvinceName = ''// 收件省份名称,
          this.formData.senderCityId = ''// 收件城市id,
          this.formData.senderCityName = ''// 收件城市名称,
          this.formData.senderAreaId = '' // 收件区域id,
          this.formData.senderStreet = '' // 收件区域名称,
          this.formData.senderProvince = '' // 收件区省/市/区
          this.formData.senderProvince = ''
          this.formData.packageLength = ''
          this.formData.packageWide = ''
          this.formData.packageHigh = ''
          this.keyBtn = false
        } else if (resData.code === 149010024) {
          this.$message.warning(resData.msg)
          this.formData.receiverProvinceId = ''// 收件省份id,
          this.formData.receiverProvinceName = ''// 收件省份名称,
          this.formData.receiverCityId = ''// 收件城市id,
          this.formData.receiverCityName = ''// 收件城市名称,
          this.formData.receiverAreaId = '' // 收件区域id,
          this.formData.receiverStreet = '' // 收件区域名称,
          this.formData.receiverProvince = '' // 收件区省/市/区
          this.formData.packageLength = ''
          this.formData.packageWide = ''
          this.formData.packageHigh = ''
          this.keyBtn = false
        } else {
          this.formData.packageLength = ''
          this.formData.packageWide = ''
          this.formData.packageHigh = ''
          this.$message.error(resData.msg)
          this.keyBtn = false
        }
      } catch (error) {
        this.keyBtn1 = false
        this.keyBtn = false
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smModeType = 1
            break
          case 319:
            smModeType = 2
            break
          case 321:
            smModeType = 3
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, ...{ smMode: smModeType }, productTypeCode }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        productTypeCode: param.expressTypeCode // 产品类型
      }
      // 调用接口
      const { code, msg, data } = await getComputationCost(params)
      if (code !== RESPONSE_SUCCESS) {
        this.$message.error(this.$lang(msg))
        this.formData.declaredValue = 0 // 清空保险价值
      }
      return data === 0 ? 0 : data || ''
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 城市重新赋值
    handleProvice(row, type) {
      // debugger
      console.log('城市重新')
      const { cityId, cityName, provinceId, provinceName, areaName, areaId, street } = row
      if (type === 1) {
        this.formData.senderProvinceId = provinceId
        this.formData.senderProvinceName = provinceName
        this.formData.senderCityId = cityId
        this.formData.senderCityName = cityName
        this.formData.senderAreaId = areaId
        this.formData.senderAreaName = areaName
        this.formData.senderStreet = street
        this.getCityInfo(provinceId, 1)
        this.getAreaInfo(cityId, 1)
      } else {
        this.formData.receiverProvinceId = provinceId
        this.formData.receiverProvinceName = provinceName
        this.formData.receiverCityId = cityId
        this.formData.receiverCityName = cityName
        this.formData.receiverAreaId = areaId
        this.formData.receiverAreaName = areaName
        this.formData.receiverStreet = street
        this.getCityInfo(provinceId)
        this.getAreaInfo(cityId)
        // Object.assign(this.receiverAddressData, { defaultData })
      }
    },

    // 查询城市数据
    async getCityInfo(provinceId, flagType) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        if (flagType === 1) {
          this.cityList = data
        } else {
          this.cityList2 = data
        }
      } else {
        this.$message.error(msg)
      }
    },

    // 查询地区
    async getAreaInfo(provinceId, flagType) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        if (flagType === 1) {
          this.areaList = data
        } else {
          this.areaList2 = data
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 收件人姓名模糊搜索
    async remoteReceiverName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(msg)
        this.loading = false
      }
    },
    // 收件人手机电话模糊搜索
    async remoteReceiverMobilePhone(queryString, cb) {
      this.loading = true
      queryString = queryString.replace('+', '')
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人姓名模糊搜索
    async remoteSenderName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人手机电话模糊搜索
    async remoteSenderMobilePhone(queryString, cb) {
      this.loading = true
      queryString = queryString.replace('+', '')
      // queryString = encodeURI(queryString).replace(/\+/g, '%2B')
      console.log(queryString)
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },

    createFilter(queryString, type) {
      return disease => {
        return (
          disease[type].toLowerCase().indexOf(queryString.toLowerCase()) !== -1 // 改为===0 就是筛选的数据只是首字匹配的列表项，需要包含输入字的所有列表项改为！==-1
        )
      }
    },

    /**
     * @description 获取回单金额
     */
    async getReceiptFee() {
      const params = {
        customerCode: this.userInfo.customerCode,
      }
      const { data, msg, code } = await getReceiptFee(params)
      if (code === RESPONSE_SUCCESS) {
        this.receiptFreight = data
        this.formData.receiptFreight = this.receiptFreight
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 检查省市区地址
    async checkArea(obj, type) {
      try {
        const { provinceId, cityId, areaId } = obj
        const { code, data } = await checkArea({ provinceId, cityId, areaId })
        if (code === 1 && data) {
          return true
        } else {
          const msg = type === 1 ? this.$lang('该寄件地址尚未开放，敬请期待') : this.$lang('该收件地址尚未开放，敬请期待')
          this.$message.warning(this.$lang(msg))
          return false
        }
      } catch (error) {
        return false
      }
    },
  },

}
</script>
<style lang="scss" scoped>
.customerStyle {
  ::v-deep .el-input__inner {
    width: 180px;
  }
}

.el-autocomplete {
  ::v-deep .my-kqoption {
    width: auto !important;
  }
}

body {
  ::v-deep .my-kqoption {
    width: 800px !important;
  }
}

.sendRemarkStyle {
  ::v-deep .el-input__inner {
    width: 360px;
  }
}

.sizeSty {
  ::v-deep .el-form-item__label {
    min-width: 450px !important;
  }
}

.sizeSty {
  ::v-deep .el-form-item__content {
    min-width: 450px !important;
  }
}

.sizeSty {
  ::v-deep .el-input {
    width: 80px !important;
    //  .el-input__inner{
    //    width: 80px !important;
    // }

  }
}
.isSigndan {
    display: flex;
    align-items: center;
    font-size: 18px;
    margin: 20px 8px 0px 8px;
    color: #888888;
    .tit {
      margin: 0 26px 0 10px;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow:ellipsis;
    }
  }
.bc-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  text-align: center;
}

.singleOrder {
  padding: 0 24px;

  h3 {
    font-size: 20px
  }

  .width100 {
    width: 100%;
  }

  .w360 {
    width: 100%;

    .el-input {
      width: 360px !important;
    }
  }

}

#areaCodeSty {
  width: 80px;
  // span {
  //   width: 80px;
  // }
  .el-input {
    ::v-deep .el-form-item__content {
      width: 80px !important;
    }
  }

  // ::v-deep .el-input__inner {
  //   width: 80px;
  // }
}

.group-title {
  border-bottom: 1px dashed #EEEEEE;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;

  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #E0BD7B;
  }

  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;

    .icon {
      color: #E0BD7B;
      position: absolute;
      overflow: visible;
    }

    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}

.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;

  .el-textarea__inner {
    min-height: 60px;
  }

  .oper {
    position: absolute;
    right: 20px;
    bottom: 5px;
    cursor: pointer;
    color: #333;

    .red {
      color: red;
      margin-right: 20px;
    }
  }
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content {
  position: relative;

  .btn-insured {
    color: #e60012;;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: -22px;
    display: inline-block;
    height: 22px;
    line-height: 16px;

    &:hover {
      text-decoration: underline;
    }
  }
}

.el-form-item.declaredValue {
  .el-input-number .el-input__inner {
    text-align: left;
  }
}

.singleOrder {
  .el-form-item__label {
    width: 180px !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
